import React, { FC } from 'react';
import {
    FormControlLabelProps,
    FormControlLabel,
} from '@mui/material';

import { Typography, TypographyProps } from '../Typography';
import { Checkbox, CheckboxProps } from '../Checkbox';


export type CheckboxWithLabelProps = Omit<FormControlLabelProps, 'control'> &
CheckboxProps & {
    typographyProps?: TypographyProps;
};

export const CheckboxWithLabel: FC<CheckboxWithLabelProps> = ({
    color,
    label,
    name,
    disabled,
    readOnly,
    required,
    typographyProps,
    size,
    sx,
    ...props
}) => (
    <FormControlLabel
        label={(
            <Typography
                ml={4}
                variant='mediumBody2'
                color={disabled && !readOnly ? 'grayscale.shade90' : 'grayscale.shade100'}
                {...typographyProps}
            >
                {label}
            </Typography>
        )}
        control={(
            <Checkbox
                color={color}
                name={name}
                required={required}
                size={size}
                readOnly={readOnly}
            />
        )}
        disabled={disabled}
        sx={[
            {
                ml: 0,
            },
            ...Array.isArray(sx) ? sx : [sx],
        ]}
        {...props}
    />
);
